export default "__VITE_PUBLIC_ASSET__47a46398__"